module.exports = __webpack_public_path__ + "img/sec5.52b30c09.jpg";